module.exports = __webpack_public_path__ + "img/o11.3ae62623.jpg";